import { ProgressBar, ProgressRing } from '@/components/ui';
import { useIsMobile } from '@/lib/useMediaQuery';
import type { TimerApi } from '@/timer/useTimer';

/** The clock shrinks when it grows an hours field so a tracked run still fits inside the ring (4a 104px, 8a 84px). */
const clockSize = (clock: string, mobile: boolean) => (mobile ? (clock.length > 5 ? 52 : 68) : clock.length > 5 ? 84 : 104);

/** Ring / Bar / Digits (Settings › Timer, the Timer style card). The clock is the largest thing on screen; mono, tabular, tight. */
export function TimerDisplay({ api, color }: { api: TimerApi; color: string }) {
  const { settings, clock, progress, status, isCountdown, timer } = api;
  const mobile = useIsMobile();
  const size = clockSize(clock, mobile);

  const face = (
    <div>
      <div role="timer" aria-label={isCountdown ? 'Time remaining' : 'Time tracked'} aria-live="off"
        className="font-mono font-medium tabular-nums text-ink select-none" style={{ fontSize: size, letterSpacing: '-.05em', lineHeight: 1 }}>
        {clock}
      </div>
      <p className="mt-3 mb-0 text-[13px] font-bold uppercase tracking-[.04em] text-ink-2 max-w-[300px] mx-auto truncate" aria-live="polite">{status}</p>
    </div>
  );

  if (settings.timerStyle === 'ring') return <ProgressRing size={mobile ? 280 : 380} progress={progress} color={color} variant={isCountdown ? 'drain' : 'marker'} running={timer.status === 'running'}>{face}</ProgressRing>;
  return (
    <div className="flex flex-col items-center justify-center w-full max-w-[420px] min-h-[200px] md:min-h-[300px]">
      {face}
      {settings.timerStyle === 'bar' && <ProgressBar value={isCountdown ? 1 - progress : progress} color={color} className="mt-7" />}
    </div>
  );
}
